// extracted by mini-css-extract-plugin
export var alignCenter = "_7v-d";
export var bannerShown = "_7v-6";
export var buttonContent = "_7v-0";
export var cardList = "_7v-1";
export var centerContent = "_7v-2";
export var chevron = "_7v-3";
export var closePanelButton = "_7v-k";
export var conversationContextContainer = "_7v-l";
export var conversationDetailContainer = "_7v-4";
export var detailWrapper = "_7v-7";
export var dropdownButton = "_7v-e";
export var dropdownTitle = "_7v-9";
export var fullHeight = "_7v-5";
export var hidden = "_7v-a";
export var icon = "_7v-b";
export var mergeSuggestionWrapper = "_7v-m";
export var panel = "_7v-i";
export var portalButtonsWrapper = "_7v-c";
export var right = "_7v-j";
export var tableSummaryContainer = "_7v-8";
export var tableSummaryHeader = "_7v-g";
export var threeDotsButton = "_7v-f";
export var wide = "_7v-h";